(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("practicalEvaluationLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/practicalEvaluationLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessPracticalEvaluationResource", "$state", PracticalEvaluationLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function PracticalEvaluationLearnerAccessCtrl(assignmentLearnerAccessPracticalEvaluationResource, $state) {
        var vm = this;
        vm.number = $state.params.number;
        vm.version = $state.params.version;
        vm.code = $state.params.code;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            vm.evaluation = assignmentLearnerAccessPracticalEvaluationResource.get({ id: vm.assignment.id }, function () {
                vm.parentCtrl.contentLoaded = true;
            });
        };
    }
}());
